<template>
  <div class="ui form">
    <div class="field">
      <label for="language">{{ $t('chooseLanguage') }}</label>
      <select class="ui compact selection fluid dropdown" id="search-select-language" v-model="lang">
        <option value="en">English</option>
        <option value="ar">العربية</option>
      </select>
    </div>
    <div class="ui submit button" @click="update">{{ $t('update') }}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      lang: this.$auth.user().language
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('#search-select-language').dropdown()
    })
  },
  methods: {
    update () {
      this.$http.post(`users/${this.$auth.user().id}/update/language`, {lang: this.lang}).then(response => {
        this.changeStyleSheet(response.data.language)
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/users/users_components/UpdateLanguage.vue